import PropTypes from 'prop-types';
import { VIEW_DATE_FORMAT } from 'utils/constants/date';
import { formatDate } from 'utils/date';

import TableCell from 'components/Table/TableCell';
import TableRow from 'components/Table/TableRow';

const Charge = ({ paymentIds, date, amount }) => {
    const ids = paymentIds.join(',');
    return (
        <TableRow>
            <TableCell>{formatDate(date, VIEW_DATE_FORMAT)}</TableCell>
            <TableCell>{amount}</TableCell>
            <TableCell>{ids}</TableCell>
        </TableRow>
    );
};

Charge.propTypes = {
    paymentIds: PropTypes.arrayOf(PropTypes.number),
    date: PropTypes.string,
    amount: PropTypes.number,
};

export default Charge;
